<template>
    <generic-page>
        <b-btn
            variant="link"
            size="lg"
            class="pl-0"
            :to="`/creator/creatorVideo/edit/${creatorVideoId}`"
        >
            <font-awesome-icon size="lg" icon="fa-light fa-chevron-left" />
            Back to Video
        </b-btn>

        <div v-if="creatorVideo">
            <h5 class="mb-3">Share & Promote</h5>

            <div class="video-preview">
                <img
                    :src="
                        creatorVideo.previewUrl || creatorVideo.thumbnailUrl
                    "
                    class="video-preview-thumb"
                />
                <div class="video-preview-info">
                    <div
                        v-if="creatorVideo.message"
                        class="text-truncate mb-1"
                    >
                        {{ creatorVideo.message }}
                    </div>
                    <div class="text-secondary small">
                        {{ creatorVideo.publishDateTerse }}
                    </div>
                </div>
            </div>

            <div class="section-label">Video Link</div>
            <b-input-group>
                <b-form-input
                    :value="creatorVideo.urlVanity"
                    readonly
                />
                <b-input-group-append>
                    <b-btn @click="copyUrl" variant="primary">
                        <font-awesome-icon
                            :icon="hasCopied ? 'fa-light fa-check' : 'fa-light fa-copy'"
                            class="mr-1"
                        />
                        {{ hasCopied ? "Copied" : "Copy" }}
                    </b-btn>
                </b-input-group-append>
            </b-input-group>
            <div v-if="hasCopied" class="small text-success mt-1">
                <font-awesome-icon icon="fa-light fa-check" />
                URL has been copied — share it on social media, chat apps, or
                anywhere to get more views!
            </div>

            <div class="section-label">QR Code</div>
            <div class="qr-section">
                <div v-if="qrCode">
                    <img
                        class="qr-image"
                        :src="qrCode"
                    />
                    <div class="text-secondary small text-center mt-2">
                        Customers can scan this code to watch your video
                    </div>
                </div>
                <div v-else class="text-center py-4">
                    <generic-loading />
                </div>
            </div>

            <div class="section-label">Tips</div>
            <b-list-group flush class="tips-list">
                <b-list-group-item class="tips-item">
                    <font-awesome-icon
                        icon="fa-duotone fa-mobile"
                        class="tips-icon text-primary"
                    />
                    <div class="small">
                        Share your link on WhatsApp, Telegram, or any messaging
                        app to reach customers directly
                    </div>
                </b-list-group-item>
                <b-list-group-item class="tips-item">
                    <font-awesome-icon
                        icon="fa-duotone fa-camera"
                        class="tips-icon text-info"
                    />
                    <div class="small">
                        Screenshot the QR code and add it to your social media
                        stories or posts
                    </div>
                </b-list-group-item>
                <b-list-group-item class="tips-item">
                    <font-awesome-icon
                        icon="fa-duotone fa-trophy"
                        class="tips-icon text-warning"
                    />
                    <div class="small">
                        More views means more upvotes — climb the Spotlight
                        leaderboard and win prizes
                    </div>
                </b-list-group-item>
            </b-list-group>
        </div>
        <div v-else>
            <generic-loading />
        </div>
    </generic-page>
</template>

<style scoped>
.video-preview {
    display: flex;
    gap: 12px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
}

.video-preview-thumb {
    width: 60px;
    aspect-ratio: 9 / 16;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
}

.video-preview-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
}

.section-label {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #64748b;
    padding: 16px 0 6px;
}

.qr-section {
    text-align: center;
    padding: 20px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
}

.qr-image {
    height: 200px;
    width: 200px;
    border-radius: 8px;
    background-color: #fff;
}

.tips-list {
    border-radius: 10px !important;
    overflow: hidden;
}

.tips-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
}

.tips-icon {
    width: 20px;
    text-align: center;
    flex-shrink: 0;
    margin-top: 2px;
}
</style>

<script>
import copy from "clipboard-copy";

export default {
    data() {
        return {
            qrCode: null,
            hasCopied: false,
        };
    },
    computed: {
        creatorVideoId() {
            return this.$route.params?.id;
        },
        creatorVideo() {
            return this.$store.state.creatorVideo.creatorVideo;
        },
    },
    created() {
        if (this.creatorVideoId) {
            this.$store.dispatch("creatorVideo/get", {
                creatorVideoId: this.creatorVideoId,
            });
        }
        this.refreshQrCode();
    },
    methods: {
        copyUrl() {
            copy(this.creatorVideo.urlVanity);
            this.hasCopied = true;
        },
        refreshQrCode() {
            this.api
                .post(`/creatorVideo/${this.creatorVideoId}/qrcode`)
                .then((response) => {
                    if (response?.data?.qrCode) {
                        this.qrCode = response.data.qrCode;
                    }
                });
        },
    },
};
</script>
